module.exports = __webpack_public_path__ + "static/media/play-egg-broken.8d45aa72.mp3";